import request from '@/utils/request';

// 查询缓存名称列表
export function exporExcelList(query: any, data: any) {
  return request({
    url: '/export/excel/list',
    method: 'post',
    params: query,
    data,
  });
}
/**
 * 下载次数
 * @param id
 */
export function downloadCount(id: any) {
  return request({
    url: `/export/excel/downloadCount/${id}`,
    method: 'get',
  });
}

/**
 * 删除导出记录
 * @param id
 */
export function delExportRecord(id) {
  return request({
    url: `/export/excel/${id}`,
    method: 'delete',
  });
}

/**
 * 修改导出记录
 * @param data
 */
export function updateExportRecord(data) {
  return request({
    url: '/export/excel/updateExportRecord',
    method: 'put',
    data,
  });
}

// 导出组件API
export function exporExcelApi(url: any, data: any, params: any) {
  return request({
    url,
    method: 'post',
    params,
    data,
  });
}
